module.exports = __webpack_public_path__ + "static/concept4-sp-342235c52b14610cfecf01a76558b2df.svg";